import { chat } from "../types";


export const getChats = ({ page, limit, query, dropdown, show_mentioned, type, is_active }) => {
    return {
        type: chat.GET_CHATS_REQUEST,
        payload: { page, limit, query, dropdown, show_mentioned, type, is_active }
    };
};

export const createChat = ({ payload, onSuccess = () => { }, formName, teams }) => {
    return {
        type: chat.CREATE_CHAT_REQUEST,
        payload: { payload, onSuccess, formName, teams }
    };
};
export const getChatMedia = ({ id, type, limit, page, }) => {
    return {
        type: chat.GET_CHAT_MEDIA_REQUEST,
        payload: { id, type, limit, page, }
    };
};
export const getCustomerMedia = ({ id }) => {
    return {
        type: chat.GET_CUSTOMER_MEDIA_REQUEST,
        payload: { id }
    }
}
export const getChatById = ({ id, setChatId }) => {
    return {
        type: chat.GET_CHAT_BY_ID_REQUEST,
        payload: { id, setChatId }
    }
}
export const deleteChatById = ({ }) => {
    return {
        type: chat.DELETE_CHAT_REQUEST,
        payload: {}
    }
}
export const addMembersInChat = ({ payload, id, formName }) => {
    return {
        type: chat.ADD_MEMBER_IN_CHAT_REQUEST,
        payload: { payload, id, formName }
    }
}
export const getMembersInChat = ({ id }) => {
    return {
        type: chat.GET_MEMBER_IN_CHAT_REQUEST,
        payload: { id }
    }
}
export const removeMembersInChat = ({ id, users, navigate }) => {
    return {
        type: chat.REMOVE_MEMBER_IN_CHAT_REQUEST,
        payload: { id, users, navigate }
    }
}
export const updateMembersInChat = ({ }) => {
    return {
        type: chat.UPDATE_MEMBER_ROLE_IN_CHAT_REQUEST,
        payload: {}
    }
}

export const getChatMessages = ({ id, q, limit, cursor, target_message_id, direction, onSuccess, source }) => {
    return {
        type: chat.GET_CHAT_MESSAGES_REQUEST,
        payload: { id, q, limit, cursor, target_message_id, direction, onSuccess, source }
    }
}
export const sendChatMessages = ({ id, payload }) => {
    return {
        type: chat.SEND_MESSAGE_REQUEST,
        payload: { id, payload }
    }
}


export const openChatModal = ({ chatId, buttonName, isRightClick, teams, defaulOpentChecklist = false, openInBackground = false }) => {
    return {
        type: chat.OPEN_CHAT_MODAL_REQUEST,
        payload: { chatId, buttonName, isRightClick, teams, defaulOpentChecklist, openInBackground }
    }
}

export const closeChatModal = ({ chatId }) => {
    return {
        type: chat.CLOSE_CHAT_MODAL_REQUEST,
        payload: { chatId }
    }
}

export const getChatUsers = ({ limit = 100, page = 1, org_id, q }) => {
    return {
        type: chat.GET_CHAT_USERS_REQUEST,
        payload: { limit, page, org_id, q }
    }
}


export const editChatMessage = ({ id, payload, messageId }) => {
    return {
        type: chat.EDIT_CHAT_MESSAGE_REQUEST,
        payload: { id, payload, messageId }
    }
}

export const deleteChatMessage = ({ id, messageId }) => {
    return {
        type: chat.DELETE_CHAT_MESSAGE_REQUEST,
        payload: { id, messageId }
    }
}

export const updateChatById = ({ id, payload }) => {
    return {
        type: chat.UPDATE_CHAT_BY_ID_REQUEST,
        payload: { id, payload }
    }
}

export const addTeamsToChat = ({ id, teamIds, onSuccess, formName }) => {
    return {
        type: chat.ADD_TEAMS_TO_CHAT_REQUEST,
        payload: { id, teamIds, onSuccess, formName }
    }
}

export const removeTeamsFromChat = ({ id, teamIds, onSuccess, formName }) => {
    return {
        type: chat.REMOVE_TEAMS_FROM_CHAT_REQUEST,
        payload: { id, teamIds, onSuccess, formName }
    }
}


export const getChatLogs = ({ id }) => {
    return {
        type: chat.GET_CHAT_LOGS_REQUEST,
        payload: { id }
    }
}

export const readMessage = ({ id }) => {
    return {
        type: chat.READ_MESSAGE_REQUEST,
        payload: { id }
    }
}


export const clearChatMessages = ({ id }) => {
    return {
        type: chat.CLEAR_CHAT_MESSAGES,
        payload: { id }
    }
};

export const updateMediaStatus = ({ id, payload, formName, chat_id, message_id }) => {
    return {
        type: chat.UPDATE_MEDIA_STATUS_REQUEST,
        payload: { id, payload, formName, chat_id, message_id }
    }
};

export const chatNotification = ({ id, mode }) => {
    return {
        type: chat.CHAT_NOTIFICATION_REQUEST,
        payload: { id, mode }
    }
}

export const closeChatRequest = ({ id, formName, navigate }) => {
    return {
        type: chat.CLOSE_CHAT_REQUEST,
        payload: { id, formName, navigate }
    }
}


export const getUsersForMentions = ({ query }) => {
    return {
        type: chat.GET_USERS_FOR_MENTIONS_REQUEST,
        payload: { query }
    }
}
